import React, { useState } from "react";
import { View, StyleSheet } from "react-native";

import { IconButton, CameraMenu } from "components";
import { Device, FilePicker } from "utils";

export const CameraButton = props => {
  const { photo, video, onCapture: _onCapture } = props;
  const [menuVisible, setMenuVisible] = useState(false);

  const onCapture = (file, type) => {
    _onCapture(file, type);
    setMenuVisible(false);
  };

  const label =
    photo && video ? "Add Image / Video" : video ? "Add Video" : "Add Image";

  if (Device.IS_MOBILE_WEB) {
    return (
      <FilePicker photo={photo} video={video} onCapture={onCapture}>
        <IconButton text={label} icon="camera" />
      </FilePicker>
    );
  }

  return (
    <View>
      <IconButton
        text={label}
        icon="camera"
        onPress={() => setMenuVisible(!menuVisible)}
      />
      {menuVisible && (
        <CameraMenu
          photo={photo}
          video={video}
          onCapture={onCapture}
          style={styles.menu}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  menu: {
    left: 40,
    top: 60,
  },
});
